import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, HTTP_INTERCEPTORS, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './modules/nav-menu/nav-menu.component';
import { UserService, IUser } from './core/auth/user.service';
import { catchError, of, lastValueFrom } from 'rxjs';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { IndexSummaryTable } from './pages/dashboard/table/index-summary-table.component';
import { RouterModule, Routes } from '@angular/router';
import { JwtInterceptor } from './core/auth/jwt.interceptor';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AccessTokenInterceptor } from './core/auth/access-token.interceptor';
import { DetailsComponent } from './pages/details/details.component';
import { MessageComponent } from "./shared/message/message.component";
import { DetailsTableComponent } from './pages/details/table/details-table/details-table.component';
import { ReactiveFormsModule } from '@angular/forms';
import { IndexSummaryTableService } from './pages/dashboard/table/index-summary-table.service';
import { SortIcon, SortableColumn } from './pages/dashboard/table/sort';

const appRoutes: Routes = [
    {
        path: 'details/:loadId',
        component: DetailsComponent,
        pathMatch: 'full'
    },
    {
        path: '',
        component: DashboardComponent
    },
    {
        path: '**',
        redirectTo: ''
    }
];

export function initConfig(userService: UserService): () => Promise<any> {
    return () => {
        return lastValueFrom(userService.login().pipe(catchError(err => of(<IUser>{}))));
    };
}

@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent,
        DashboardComponent,
        IndexSummaryTable,
        DetailsComponent,
        MessageComponent,
        DetailsTableComponent,
        SortableColumn,
        SortIcon
    ],
    bootstrap: [AppComponent],
    imports: [
        RouterModule.forRoot(appRoutes),
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ReactiveFormsModule
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initConfig,
            deps: [UserService],
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AccessTokenInterceptor, multi: true },
        IndexSummaryTableService
    ],
    exports: [
        BrowserAnimationsModule
    ]
})
export class AppModule { }
